/* eslint-disable */
<template>
  <!-- Content Wrapper -->
  <div class="content">
    <!-- Main Content -->
    <section class="flexib-container">
      <div style="text-align:left;">
        <small>
          Selection: {{this.getSelection}}
        </small>
      </div>
      <div style="text-align:right;">
        <small>
          Last Updated: {{this.lastUpd}}
          <i>- API: {{apiurl}}</i>
        </small>
      </div>
    </section>

    <section class="flex-container">
      <!-- <div class="card shadow text-center" v-for="(value, key) in csummary" :key="key"> -->
      <div class="card shadow" v-for="(value, key) in csummary" :key="key">
        <div class="card-body" :id="key">
          <div class="flex-container">
            <!-- <div class="mr-4 text-uppercase"> -->
            <div>
              <div><strong>{{key}}</strong></div>
              <div>{{ value.value | formatIt }}</div>
            </div>
            <div>
              <!-- <div><i :class="value.icon"></i></div> -->
              <div><span class="iconsm">{{value.icon}}</span></div>
              <div>{{value.pct}}</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- <div v-else-if="key==='lastUpdate'">
            <div style="text-align:right;">
              <small>Last Updated: {{value}}</small>
            </div>
    </div>-->

    <!-- <div v-else-if="key=='image'"> -->
    <!-- The graph image from API is displayed -->
    <!-- <div class="row d-flex flex-row align-items-center justify-content-around"> -->
    <div class="flex-container">
      <!-- <div class="col-sm-6 col-lg-6 col-6 mb-3" v-if="this.worldrcntry === 'world'"> -->
      <!-- <div class="col-sm-6 col-lg-6 col-6 mb-3"> -->
      <div class="imgcontainer" :style="chartSizepct">
        <img v-bind:src="this.imgurl" class="imgw rounded" alt="the graph" />
        <!-- <img src="../assets/logo.png" :style=this.imagesize class="imgws rounded" alt="the graph" /> -->
      </div>
      <!-- <div class="col-sm-6 col-lg-6 col-6 mb-3"> -->
      <div class="imgcontainer">
        <reactive
          :style="chartSizepx"
          :chart-data="wdchartdata"
          :options="{responsive: true, maintainAspectRatio: false}"
        ></reactive>
      </div>
    </div>
    <!-- </div> -->

    <!-- The last section -->
    <!-- <div class="row d-flex flex-row  justify-content-left align-items-left" -->
    <!-- <div class="row d-flex flex-row mt-3 justify-content-center align-items-left"> -->
    <div class="flexc-container">
      <div v-for="(wc,index) in wrc" :key="index">
        <input
          type="radio"
          :id="wc.lbl"
          :value="wc.value"
          name="wc.lbl"
          v-model="worldrcntry"
          @change="getsummary()"
        />
        <label :for="wc.lbl">
          <!-- <i :class="wc.icon"></i> -->
          <span class="icon">{{wc.icon}}</span>
          {{ wc.lbl }}
        </label>
      </div>

      <div class="marginc">
        <button class="cbutton bg-primary text-light" :key="this.clist" @click="showModal">Details...</button>

        <Cmodal
          :gdata="this.gridData"
          :columns="this.gridColumns"
          :footer="this.gridFooter"
          :mhead=this.getSelection
          v-show="modalVisible"
          @close="closeModal"
          v-if="this.gridData.length > 0"
        />
      </div>

      <!-- <select class="ml-5 mr-2 mb-5" v-model="clist" @change="getsummary()"> -->
      <select v-model="clist" @change="getsummary()">
        <option v-for="(cntry, index) in this.cntrys" :key="index" :value="cntry.name">
          <!-- <option v-for="(cntry, index) in this.cntrys" :key="index" :value="cntry.iso3"> -->
          {{cntry.name}}
        </option>
      </select>
      <!-- <span>Selected: {{clist}} </span> -->

      <span ref="dp" class="ui left action input">
        <button class="ui cbutton" data-toggle><span class="icon">📅</span></button>
        <!-- <button class="ui icon button" data-toggle><i class="calendar icon"></i></button> -->
        <input
          type="text"
          v-model="cdate"
          :readonly="readonly"
          @change="$emit('input', $event.target.value)"
          data-input
        />
        <button class="ui cbutton" data-clear><span class="icon">❌</span></button>
        <!-- <button class="ui" data-clear><i class="fa fa-times"></i></button> -->
        <!-- <button class="ui inverted icon button" data-clear><i class="remove red icon"></i></button> -->
      </span>
    </div>

    <!-- </section> -->
    <!-- </div> -->
    <!-- </div> -->
  </div>
</template>
<script>
import axios from "axios";
import flatpickr from "flatpickr";
import wsm from "../mixin/mixin";
import Cmodal from "../components/layout/Modal.vue";

import { APIServiceCovid } from "../apis/apiservices";
import Reactive from "../components/layout/Reactive.vue";

const apiService = new APIServiceCovid();

function formatIt(value) {
  const formatter = new Intl.NumberFormat("en-IN", {
    /*   style: 'currency', currency: 'USD', */
    minimumFractionDigits: 0
  });
  if (typeof value !== "number") {
    return value;
  }
  return formatter.format(value);
}

export default {
  components: { Reactive, Cmodal },
  data() {
    return {
      title: 'Foo Page',
      modalVisible: false,
      csummary: {},
      apiurl: "https://covid19.mathdro.id/api",
      imgurl: "",
      lastUpd: "",
      // wrc: [
      //   { lbl: "World", value: "world", icon: "fas fa-fw fa-globe-asia" },
      //   { lbl: "Countries", value: "ctry", icon: "fas fa-fw fa-flag" }
      // ],
      wrc: [
        { lbl: "World", value: "world", icon: "🌏" },
        { lbl: "Countries", value: "ctry", icon: "🏳️" }
      ],
      worldrcntry: "world",
      clist: "India",
      cntrys: [
        { name: "Afghanistan", iso2: "AF", iso3: "AFG" },
        { name: "Albania", iso2: "AL", iso3: "ALB" },
        { name: "India", iso2: "IN", iso3: "IND" }
      ],
      wdchartdata: {},
      imagesize: { height: "37%", width: "31%" },
      isLoading: false,
      // confirmed: "far fa-2x fa-meh",
      // deaths: "far fa-2x fa-frown",
      // recovered: "far fa-2x fa-smile",
      // active: "far fa-meh-rolling-eyes",
      confirmed: "😐",
      deaths: "😟",
      recovered: "🙂",
      active: "🤨",

      gridData: [],
      gridColumns: [],
      gridFooter:
        "Let's keep the fight, together we shall conquer Covid19🦠😷.... <a href='https://thewire.in/culture/art-poetry-covid-19-pandemic' target='_blank' rel='external'>Check this!</a> &amp;<a href='https://economictimes.indiatimes.com/news/politics-and-nation/coronavirus-pandemic-inspires-the-art-of-graffiti-in-india/a-health-warning/slideshow/75044229.cms' target='_blank' rel='external'>this</a>.",
      cdate: "06-30-2020",
      cdetail: [],
      dp: null,
      readonly: Boolean
    };
  },
  mixins: [wsm],
  filters: { formatIt },
  methods: {
    dpInitiate() {
      if (!this.dp) {
        this.dp = flatpickr(".ui.input", {
          wrap: true,
          altFormat: "m-d-Y",
          // altInput: true,
          dateFormat: "m-d-Y",
          minDate: "01-22-2020",
          maxDate: 'today',
          defaultDate: 'today',
          // defaultDate: new Date().fp_incr(-1),
          // maxDate: new Date().fp_incr(-1)
          allowInput: true,
        });
      }
    },

    async getsummary1() {
      this.isLoading = false;
      const wg = "no";
      let url = `${this.apiurl}`;
      if (this.worldrcntry !== "world") {
        url = `${this.apiurl}/countries/${this.clist}`;
      }
      this.imgurl = `${url}/og`;

      try {
        this.csummary = await apiService.getDataGlobal(url, wg);
        this.isLoading = true;
      } catch (error) {
        console.log("error-", error);
      }
      this.getchartdata();
    },

    setColumns(gc) {
      let gd;
      if (gc === "" || gc === [] || gc.length !== 1) {
        gd = this.$root.log1(this.gridData);
        gd = Object.keys(gd[0]);
      } else {
        gd = gc;
      }
      return gd;
    },

    showModal() {
      this.modalVisible = true;
      // this.gridData = this.cdetail;
      this.getDetails();
    },
    closeModal() {
      this.isLoading = false;
      this.modalVisible = false;
    },
    filterSummary() {
      const items = this.csummary;
      const result = {};
      let cval = '';
      // if (this.csummary.value === null) { return this.csummary; } // no filterning
      Object.keys(items).forEach(key => {
        const item = items[key];

        if (typeof item.value === "number") {
          this.$set(item, "value", item.value);
          this.$set(item, "icon", this[key]);
          if (key === "confirmed") {
            cval = parseInt(item.value, 10);
          } else {
            this.$set(item, "pct", `${Math.round(((parseInt(item.value, 10) / cval) * 100) * 100) / 100} %`);
          }
          result[key] = item;
        } else if (key === "image") {
          this.imgurl = item;
        } else if (key === "lastUpdate") {
          this.lastUpd = item;
        }
      });
      return result;
    },
    filterData(items, cname) {
      const result = {};
      Object.keys(items).forEach(key => {
        const item = items[key];
        if (item.countryRegion === cname) {
          result[key] = item;
        }
      });
      return result;
    },
    // world level summary and country wise data
    async getsummary() {
      this.isLoading = false;
      let url = `${this.apiurl}`;
      if (this.worldrcntry !== "world") {
        url = `${this.apiurl}/countries/${this.clist}`;
        this.imgurl = `${url}/og`;
      }

      try {
        this.csummary = await apiService.getDataGlobal(url);
        this.csummary = this.filterSummary();
      } catch (error) {
        console.log("error-", error);
      }
      this.getchartdata();
      this.getDetails();
      this.isLoading = false;
    },
    async getCountryList() {
      this.cntrys = await apiService.getCountryList(this.apiurl);
    },

    async fetchCntryData1() {
      const gd = await apiService.fetchCntryData(this.clist);
    },

    async getDetails() {
      this.isLoading = false;
      this.gridColumns.splice(0, this.gridColumns.legth - 1);
      let url = `${this.apiurl}/daily`;
      if (this.worldrcntry !== "world") {
        url = `${this.apiurl}/daily/${this.cdate}`;
      }

      try {
        this.cdetail = await apiService.getDataGlobalDetails(
          url,
          this.clist,
          this.worldrcntry
        );
        this.gridData = this.cdetail;
        this.gridColumns = this.gridColumns.splice();
        const ngd = this.setColumns(this.gridColumns);
        this.gridColumns.push(...ngd);

        this.isLoading = true;
      } catch (error) {
        console.log("error-", error);
      }
      this.isLoading = false;
    },

    // get the data for chart preparation!
    async getchartdata() {
      let url = `${this.apiurl}/daily`;
      if (this.worldrcntry !== "world") {
        url = `${this.apiurl}/countries/${this.clist}`;
      }

      apiService
        .getDataGlobal(url)
        .then(data => {
          this.isLoading = false;
          const xaxislabel = [];
          const yaxisdata1 = [];
          const yaxisdata2 = [];

          if (this.worldrcntry === "world") {
            Object.entries(data).forEach(([key, value]) => {
              xaxislabel.push(value.reportDate);
              yaxisdata1.push(value.confirmed.total);
              yaxisdata2.push(value.deaths.total);
            });
          } else {
            Object.entries(data).forEach(([key, value]) => {
              xaxislabel.push(key);
              yaxisdata1.push(value.value);
            });
          }
          this.wdchartdata = {
            // Data for the y-axis of the chart
            labels: xaxislabel,
            datasets: [
              {
                label: "Confrmed",
                backgroundColor: "#f87979",
                // Data for the x-axis of the chart
                data: yaxisdata1
              },
              {
                label: "Deaths",
                backgroundColor: "blue",
                // Data for the x-axis of the chart
                data: yaxisdata2
              }
            ]
          };
        })
        .catch(error => {
          console.error(error);
        })
        .finally(error => {
          this.isLoading = false;
        });
    }
  },
  computed: {
    chartSizepx() {
      return {
        height: "360px",
        width: "400px"
      };
    },
    chartSizepct() {
      return {
        height: "60%",
        width: "50%"
      };
    },
    getSelection() {
      const selec = ((this.worldrcntry === "world") ? `World` : ` Country - ${this.clist} - ${this.cdate}`);
      this.setTitle(`Covi9 19 Stats : ${this.$route.name} - ${selec}`);
      return selec;
      // return ((this.worldrcntry === "world") ? `World` : ` Country - ${this.clist} - ${this.cdate}`);
    },
  },
  mounted() {
    this.dpInitiate();
  },
  created() {
    // this.setTitle(`Covi9 19 Stats : ${this.$route.name} - ${this.getSelection}`);
    this.getCountryList();
    this.getsummary();
    this.getDetails();
  }
};
</script>

<style scoped lang="scss">
  @import "../scss/world";
</style>
